import { memo, useMemo } from "react";
import { UIDataTypes, UIMessagePart, UITools } from "ai";

import { Group, Image, Paper, Text } from "@mantine/core";

import mosaicLogo from "modules/core/assets/img/mosaic.png";

import classes from "./styles.module.css";

type ChatLoadingProps = {
  lastPartType?: UIMessagePart<UIDataTypes, UITools>["type"];
};

const ChatLoading = (props: ChatLoadingProps) => {
  const { lastPartType = "reasoning" } = props;

  const label = useMemo(() => {
    if (lastPartType === "reasoning") {
      return "Reasoning...";
    } else if (lastPartType?.startsWith("tool-")) {
      if (lastPartType === "tool-synthesize_brainstorm_idea") {
        return "Evaluating...";
      } else if (lastPartType?.startsWith("tool-display_")) {
        return "Rendering...";
      } else {
        return "Gathering information...";
      }
    } else if (lastPartType === "text") {
      return "...";
    }

    return "Thinking...";
  }, [lastPartType]);

  return (
    <Paper py="xs" px="sm" radius="xl" withBorder shadow="xs" w="fit-content">
      <Group gap="xs">
        <Image src={mosaicLogo} w={14} h={14} className={classes.logo} />

        <Text size="xs" c="gray.6" fw={600}>
          {label}
        </Text>
      </Group>
    </Paper>
  );
};

export default memo(ChatLoading);
